exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  display: inline-block;\n  margin-right: 10px;\n  position: relative;\n  top: 12px; }\n\n.status-indicator {\n  width: 12px;\n  height: 12px;\n  border-radius: 6px; }\n  .status-indicator.yellow {\n    background-color: #ffd630; }\n  .status-indicator.red {\n    background-color: #e22d43; }\n  .status-indicator.green {\n    background-color: #cbdb29; }\n  .status-indicator.empty {\n    background-color: transparent;\n    border: 1px solid #5b6779; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/shared/components/status-indicator/status-indicator.component.scss
// module id = ../../../../../src/app/shared/components/status-indicator/status-indicator.component.scss
// module chunks = 12